var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 0H1.875C0.84 0 0 0.84 0 1.875V14.625C0 15.66 0.84 16.5 1.875 16.5H7.875C8.91 16.5 9.75 15.66 9.75 14.625V1.875C9.75 0.84 8.91 0 7.875 0ZM4.875 15.75C4.2525 15.75 3.75 15.2475 3.75 14.625C3.75 14.0025 4.2525 13.5 4.875 13.5C5.4975 13.5 6 14.0025 6 14.625C6 15.2475 5.4975 15.75 4.875 15.75ZM8.25 12.75H1.5V2.25H8.25V12.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/MobileIcon.fe56d2b0b06bdc6021f564a03b25a057.svg";
export { ForwardRef as ReactComponent };